import React, { useRef, useState, useEffect } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { Button, Input, message, Space, Table } from 'antd';
import { Link } from "react-router-dom";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import firebase from '../../config/firebase';
import { useSelector } from 'react-redux';
import InputMask from 'react-input-mask';
import VisibilityIcon from '@mui/icons-material/Visibility';
import productService from '../../service/product.service';

require('firebase/auth')

const DataProductTable = () => {
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const [datas, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const searchInput = useRef(null);

    const user = useSelector(state => state.user);

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const fetchData = () => {
        let unsubscribe = null;

        setLoading(true);

        const collectionRef = firebase.firestore().collection("product");

        if (user.viewALL) {
            unsubscribe = collectionRef.onSnapshot(
                snapshot => {
                    const documents = snapshot.docs.map(doc => ({
                        id: doc.id,
                        ...doc.data()
                    }));
                    setData(documents);
                    setLoading(false);
                },
                error => {
                    console.error("Erro ao buscar dados dos produtos:", error);
                    setLoading(false);
                }
            );

        } else if (user?.uidShipperAffiliates && Array.isArray(user.uidShipperAffiliates)) {
            const affiliateUids = user.uidShipperAffiliates || [];
            const primaryUid = user?.uidShipper ? [user.uidShipper] : [];
            const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

            if (uids.length > 1) {
                unsubscribe = collectionRef
                    .where("uidShipper", "in", uids)
                    .onSnapshot(
                        snapshot => {
                            const documents = snapshot.docs.map(doc => ({
                                id: doc.id,
                                ...doc.data()
                            }));
                            setData(documents);
                            setLoading(false);
                        },
                        error => {
                            console.error("Erro ao buscar dados dos produtos:", error);
                            setLoading(false);
                        }
                    );
            } else {
                unsubscribe = collectionRef
                    .where("uidShipper", "==", user.uidShipper)
                    .onSnapshot(
                        snapshot => {
                            const documents = snapshot.docs.map(doc => ({
                                id: doc.id,
                                ...doc.data()
                            }));
                            setData(documents);
                            setLoading(false);
                        },
                        error => {
                            console.error("Erro ao buscar dados dos produtos:", error);
                            setLoading(false);
                        }
                    );
            }

        } else {
            unsubscribe = collectionRef
                .where("uidShipper", "==", user.uidShipper)
                .onSnapshot(
                    snapshot => {
                        const documents = snapshot.docs.map(doc => ({
                            id: doc.id,
                            ...doc.data()
                        }));
                        setData(documents);
                        setLoading(false);
                    },
                    error => {
                        console.error("Erro ao buscar dados dos produtos:", error);
                        setLoading(false);
                    }
                );
        }

        return unsubscribe;
    };

    useEffect(() => {
        const unsubscribe = fetchData();

        return () => {
            if (unsubscribe) unsubscribe();
        };
    }, [user]);

    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };

    async function deleteEmb(id) {
        try {
            await productService.deleteProduct(id);

            message.success("Produto excluído com sucesso!");
        }
        catch (error) {
            message.error("Erro ao excluir o produto. Tente novamente.");
            console.error(error);
        }
    };

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
        <div
            style={{
            padding: 8,
            }}
            onKeyDown={(e) => e.stopPropagation()}
        >
            <Input
            ref={searchInput}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{
                marginBottom: 8,
                display: 'block',
            }}
            />
            <Space>
            <Button
                type="primary"
                onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{
                width: 90,
                }}
            >
                Search
            </Button>
            <Button
                onClick={() => clearFilters && handleReset(clearFilters)}
                size="small"
                style={{
                width: 90,
                }}
            >
                Reset
            </Button>
            <Button
                type="link"
                size="small"
                onClick={() => {
                confirm({
                    closeDropdown: false,
                });
                setSearchText(selectedKeys[0]);
                setSearchedColumn(dataIndex);
                }}
            >
                Filter
            </Button>
            <Button
                type="link"
                size="small"
                onClick={() => {
                close();
                }}
            >
                close
            </Button>
            </Space>
        </div>
        ),
        
        filterIcon: (filtered) => (
        <SearchOutlined
            style={{
            color: filtered ? '#1677ff' : undefined,
            }}
        />
        ),

        onFilter: (value, record) =>{ 

        if (dataIndex === 'cpfCnpj') {
            const cleanValue = value.replace(/[^\w]/g, '').trim();
        
            return (
            (record.cpf && record.cpf.toString().replace(/[^\w]/g, '').toLowerCase().includes(cleanValue.toLowerCase())) ||
            (record.cnpj && record.cnpj.toString().replace(/[^\w]/g, '').toLowerCase().includes(cleanValue.toLowerCase()))
            );
        }
        else if(typeof value === 'string'){
            return record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase())
        }
        else {
            return record[dataIndex] = value
        }

        }, onFilterDropdownOpenChange: (visible) => {
        if (visible) {
            setTimeout(() => searchInput.current?.select(), 100);
        }
        },

        render: (text) =>
        searchedColumn === dataIndex ? (
            <Highlighter
            highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
            }}
            searchWords={[searchText]}loading={loading}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
            />
        ) : (
            text
        ),
    });

    const columns = [
        {
            title: 'Produto',
            dataIndex: 'product',
            key: 'product',
            ...getColumnSearchProps('product'),
            sorter: (a, b) => a.product.localeCompare(b.product),
        },
        {
            title: 'Descrição',
            dataIndex: 'description',
            key: 'description',
            ...getColumnSearchProps('description'),
            sorter: (a, b) => {
                const nameA = a.description || '';
                const nameB = b.description || '';
                return nameA.localeCompare(nameB);
            },
        },
        {
            title: 'Ativo',
            dataIndex: 'activo',
            key: 'activo',
            ...getColumnSearchProps('activo'),
            sorter: (a, b) => {
                const nameA = a.active || '';
                const nameB = b.active || '';
                return nameA.localeCompare(nameB);
            },
            render: (activo) => (
                <span>{activo ? 'Sim' : 'Não'}</span>
            ),
        },
        {
        title: 'Ações',
        key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    {/* {
                    user?.permissoes?.cliente?.editar || user?.permissoes?.client?.isEdit ? ( */}
                        <Link to={'/product/' + record.id}>
                        <EditOutlinedIcon />
                        </Link>
                    {/* )
                    :
                    (
                        <Link to={`/client/${record.id}`} state={{viewOnly: true}}>
                        <VisibilityIcon />
                        </Link>
                    )
                    } */}
                    {/* {
                    user?.permissoes?.cliente?.excluir || user?.permissoes?.client?.isDelete ? ( */}
                        <Link to={'#'}>
                            <DeleteOutlinedIcon onClick={(e) => deleteEmb(record.id)} color='error'/>
                        </Link>
                    {/* )
                    :
                    (
                        ""
                    )
                    } */}
                </Space>
            ),
        },
    ];

    return <Table columns={columns} dataSource={datas} loading={loading} />;

};

export default DataProductTable;